import React from 'react';
import { connect } from "react-redux";
import {getEmrDetails, getRemoteAccessVPN  } from '../../../services/facility/action'
import EmrConnection from "./emrConnection";
import VpnConnection from './vpnConnection';

class FacilityEmr extends React.Component{

    constructor(props){
        super(props)
        this.state = {
          cloudBaseEmr:true,
          remoteAccess:false,
          connectionType:"",
          popUp:false
        }
    }



    checkBoxChange = (e) =>{
      let selectedCkeckbox= e.target.name;
      switch(selectedCkeckbox){
        case "cloudBaseEmr":
        this.setState({
          cloudBaseEmr:true,
          remoteAccess:false
        })
        break;
        case "remoteAccess":
        this.setState({
          cloudBaseEmr:false,
          remoteAccess:true
        })
        break;
        default:
        break;
      }
    }

    componentDidMount() {
      let facilityInfo = this.props.profileDetails.commonUser.userId;
      
      let access_token = this.props.loginDetails;

       this.setState({
          access_token,
          facilityInfo
      })

      
      this.props.getRemoteAccessVPN(access_token, facilityInfo )
   
      this.props.getEmrDetails(access_token, facilityInfo )
     
  }

  componentWillReceiveProps = nextProps => {
   
    if( nextProps.emrOrVpnDetails && nextProps.emrOrVpnDetails.listEmrConnection.isDefault === "true" ){
      this.setState({
        cloudBaseEmr:true,
        remoteAccess:false
      })
  }else if(nextProps.remoteAccessVpnDetails && nextProps.remoteAccessVpnDetails.listVpnConnection.isDefault === "true"){
    this.setState({
      cloudBaseEmr:false,
      remoteAccess:true
    })
  }  

}
    render(){
    
 
      const {   
        cloudBaseEmr, 
        remoteAccess,
        } = this.state;

        return(

            <>
                 <div className="row tab-pane " id="emr_setup">
                        <form>
                          <div className="col-md-12 col-lg-12">
                          {/* <h1>{connectionType ? connectionType :"NO" } connection set as your default connection</h1> */}
                            <div className="emrradio">

                              <div className="chck">
                                <input className="inp-cbx" id="cbx" name="cloudBaseEmr" onChange={this.checkBoxChange} checked={cloudBaseEmr} type="checkbox" style={{ display: "none" }} />
                                <label className="cbx" htmlFor="cbx"><span>
                                  <svg width="12px" height="10px" viewBox="0 0 12 10">
                                    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                  </svg></span><span className="check-lab">Cloud Base EMR</span>
                                </label>
                              </div>
                              <div className="chck">
                                <input className="inp-cbx" id="cbx1" name="remoteAccess" onChange={this.checkBoxChange} checked={remoteAccess} type="checkbox" style={{ display: "none" }} />
                                <label className="cbx" htmlFor="cbx1"><span>
                                  <svg width="12px" height="10px" viewBox="0 0 12 10">
                                    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                  </svg></span><span className="check-lab">Remote Access / VPN</span>
                                </label>
                              </div>

                            </div>
                          </div>
                                {cloudBaseEmr && 
                                  <EmrConnection />
                                }
                                  {remoteAccess && 
                                    <VpnConnection />
                                  }
                        </form>
                      </div>
            </>
        )
    }
}
 


const mapStateToProps = state => ({
  loginDetails: state.commonReducer.loginDetails,
  profileDetails: state.commonReducer.profileDetails,
  emrOrVpnDetails : state.facilityReducer.emrOrVpnDetails,
  remoteAccessVpnDetails: state.facilityReducer.remoteAccessVpnDetails,
  editPractitionerSuccess : state.facilityReducer.editPractitionerSuccess,
  deletePractitionerStatus : state.facilityReducer.deletePractitionerStatus
});

const mapDispatchToProps = dispatch => ({
  getEmrDetails: (token, facilityInfo) => dispatch(getEmrDetails(token, facilityInfo)),
  getRemoteAccessVPN: (token, facilityInfo) => dispatch(getRemoteAccessVPN(token, facilityInfo)),
 // addEmploye: (Payload, token) => dispatch(addEmploye(Payload, token)),
 //editPractitioner: (Payload, token) => dispatch(editPractitioner(Payload, token)),
 //deletePractitioner: (id, token) => dispatch(deletePractitioner(id, token)),

});

export default connect(
 mapStateToProps,
 mapDispatchToProps
)(FacilityEmr);